// API client — fetch wrapper z auto-Authorization Bearer header i error handling.
// Sciezki ZAWSZE relative (Caddy reverse_proxy /api/* -> game-backend:3000).
// Token przechowywany w localStorage; 401 czysci go (wymusza re-authenticate).

const TOKEN_KEY = "tgame:session_token";

export function getStoredToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // localStorage moze byc wylaczone w incognito / quota exceeded
    // Sesja nadal dziala w pamieci tej karty, po refresh wymaga re-auth
  }
}

export function clearStoredToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    // ignore
  }
}

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    public readonly body: unknown,
  ) {
    const msg =
      typeof body === "object" && body !== null && "message" in body
        ? String((body as { message: unknown }).message)
        : "request failed";
    super(`API ${status}: ${msg}`);
    this.name = "ApiError";
  }
}

interface RequestOptions {
  method: "GET" | "POST" | "PUT" | "DELETE";
  path: string;
  body?: unknown;
}

export async function apiRequest<T>({ method, path, body }: RequestOptions): Promise<T> {
  const headers: Record<string, string> = {
    Accept: "application/json",
  };
  if (body !== undefined) {
    headers["Content-Type"] = "application/json";
  }
  const token = getStoredToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(path, {
    method,
    headers,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  const text = await res.text();
  let parsed: unknown;
  try {
    parsed = text ? JSON.parse(text) : null;
  } catch {
    parsed = text;
  }

  if (!res.ok) {
    if (res.status === 401) {
      clearStoredToken();
    }
    throw new ApiError(res.status, parsed);
  }

  return parsed as T;
}

export const apiGet = <T>(path: string): Promise<T> => apiRequest<T>({ method: "GET", path });
export const apiPost = <T>(path: string, body?: unknown): Promise<T> =>
  apiRequest<T>({ method: "POST", path, body });
